import { dia } from "@clientio/rappid";
import { CircularPort } from "../../ports";
import { TWITTER_ICON, ShapeAttributes } from "../../theme";

export default class Rectangle extends dia.Element {
  defaults(): Partial<dia.Element.Attributes> {
    return {
      ...super.defaults,
      type: "app.Rectangle",
      size: { width: ShapeAttributes.width, height: ShapeAttributes.height },
      data: {
        message: "Welcome to ContactWise",
      },
      attrs: {
        body: {
          width: ShapeAttributes.width,
          height: ShapeAttributes.height,
          rx: ShapeAttributes.rounded,
          strokeWidth: ShapeAttributes.strokeWidth,
          stroke: ShapeAttributes.stroke,
          fill: ShapeAttributes.fill,
        },
        icon: {
          width: ShapeAttributes.icon.width,
          height: ShapeAttributes.icon.height,
          refX: ShapeAttributes.icon.refX,
          refY: ShapeAttributes.icon.refY,
          x: ShapeAttributes.icon.x,
          y: ShapeAttributes.icon.y,
          xlinkHref: TWITTER_ICON,
        },
      },
      markup: [
        {
          tagName: "rect",
          selector: "body",
        },
        {
          tagName: "image",
          selector: "icon",
        },
      ],
      ports: {
        groups: {
          in: CircularPort("left", ShapeAttributes.port.in),
          error: CircularPort("bottom", ShapeAttributes.port.error),
          out: CircularPort("right", ShapeAttributes.port.out),
        },
        items: [{ group: "in" }, { group: "error" }, { group: "out" }],
      },
    };
  }
}
